import { useLocalAudioOutput } from '@providers/LocalAudioOutputProvider';
import { useEffect } from 'react';

export function useSpeakerOn() {
  const { isAudioOn, toggleAudio } = useLocalAudioOutput();

  useEffect(() => {
    if (isAudioOn) return;
    toggleAudio();
  }, []);
}
